import {
    ACTION_SET_TOGGLE_ANALYSIS_RESULT

} from './action'


export default {
  
    toggle_analysis_result(state = false, action) {
        const { type, payload } = action;
        if(type==ACTION_SET_TOGGLE_ANALYSIS_RESULT){
            return payload;
        }
        return state;
    }

}